import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Editor } from 'slate-react';
import './style.css';
import { LinkIcon } from '../../components/Icons';
import MediaToolbar from '../LightboxPlugin/components/Toolbar';
import EmbedBlock from '../../components/Embed';

var EmbedBlockComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(EmbedBlockComponent, _Component);

  function EmbedBlockComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EmbedBlockComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EmbedBlockComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showLightbox: false,
      showLightboxAtBlockKey: null,
      hasError: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleLightbox", function () {
      _this.props.editor.command('openLightbox', _this.props.node);
    });

    _defineProperty(_assertThisInitialized(_this), "onOpenLightbox", function () {
      var enableLightbox = _this.props.enableLightbox;

      if (enableLightbox) {
        _this.toggleLightbox();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onEmbedLoad", function (_ref) {
      var title = _ref.title,
          description = _ref.description,
          provider = _ref.provider;
      var _this$props = _this.props,
          node = _this$props.node,
          editor = _this$props.editor;
      if (editor.readOnly) return;
      var newData = node.data.merge({
        title: title,
        description: description,
        provider: provider
      });
      if (node.data === newData) return;
      editor.setNodeByKey(node.key, {
        data: newData
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function () {
      var _this$props2 = _this.props,
          editor = _this$props2.editor,
          node = _this$props2.node;
      if (editor.readOnly) return;
      editor.removeNodeByKey(node.key);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      if (_this.unmounted) {
        return false;
      }

      _this.setState({
        hasError: true
      });
    });

    return _this;
  }

  _createClass(EmbedBlockComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          enableLightbox = _this$props3.enableLightbox,
          iframelyApiKey = _this$props3.iframelyApiKey,
          node = _this$props3.node,
          editor = _this$props3.editor,
          isFocused = _this$props3.isFocused,
          attributes = _this$props3.attributes;
      var url = node.data.get('url');
      var title = node.data.get('title');
      var provider = node.data.get('provider');
      var blockKey = node.key;
      var readOnly = editor.readOnly;

      if (!iframelyApiKey) {
        return React.createElement("div", attributes, React.createElement("a", {
          href: url,
          className: classNames('block slite-editor-embed-block', 'width-full position-relative overflow-hidden', 'shadow-on-hover radius-normal', 'margin-top-small', {
            'is-focused': isFocused
          })
        }, React.createElement("div", {
          className: "background-shade-50"
        }, React.createElement("div", {
          className: "padding-medium flexbox flexbox-grow overflow-hidden"
        }, React.createElement("div", {
          className: "flexbox flexbox-centered pointer shade-30 padding-right-normal"
        }, React.createElement(LinkIcon, {
          size: 24
        })), React.createElement("div", {
          className: "flexbox-grow flexbox flexbox-column flexbox-justify-center ellipsis"
        }, React.createElement("div", {
          className: "shade-00 font-weight-bold ellipsis"
        }, title), React.createElement("div", {
          className: "shade-20 primary-on-hover ellipsis"
        }, provider || url)), React.createElement("div", {
          className: "padding-vertical-medium flexbox"
        }, !readOnly && React.createElement(MediaToolbar, {
          blockKey: blockKey,
          url: url,
          allowDownload: false,
          readOnly: readOnly,
          error: this.state.hasError,
          onRemove: this.onRemove
        }))))));
      }

      return React.createElement("div", attributes, React.createElement("div", {
        className: classNames('slite-editor-embed-block', 'width-full position-relative overflow-hidden', 'shadow-on-hover radius-normal', 'margin-top-small', {
          'is-focused': isFocused
        })
      }, React.createElement(EmbedBlock, {
        iframelyApiKey: iframelyApiKey,
        url: url,
        onLoad: this.onEmbedLoad,
        onError: this.onError
      }), React.createElement(MediaToolbar, {
        blockKey: blockKey,
        toggleLightbox: this.toggleLightbox,
        enableLightbox: enableLightbox,
        url: url,
        allowDownload: false,
        readOnly: readOnly,
        error: this.state.hasError,
        onRemove: this.onRemove
      })));
    }
  }]);

  return EmbedBlockComponent;
}(Component);

_defineProperty(EmbedBlockComponent, "propTypes", {
  iframelyApiKey: PropTypes.string,
  enableLightbox: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  node: PropTypes.object,
  attributes: PropTypes.object,
  editor: PropTypes.instanceOf(Editor)
});

export default EmbedBlockComponent;